import Axios from "axios";
import useAuthStore from "../../stores/useAuthStore";

const openDrawer = () => {
  // CW Browser (Electron) exposes a native serial/network cash drawer bridge —
  // use it directly and skip the legacy hardware-controller Axios call.
  if (window.electronAPI?.hardware?.openDrawerConfigured) {
    console.log("[openDrawer] Electron path");
    window.electronAPI.hardware
      .openDrawerConfigured("sale")
      .then((result) => {
        if (result?.success) {
          console.log("[openDrawer] openDrawerConfigured succeeded");
        } else {
          console.warn("[openDrawer] openDrawerConfigured failed:", result?.error);
        }
      })
      .catch((err) => console.warn("[openDrawer] openDrawerConfigured threw:", err?.message));
    return;
  }

  const tillData = useAuthStore.getState().tillData;
  const printerURL = tillData?.tillAccess?.cwrTill?.hardwareController?.imageUrl;
  if (!printerURL) {
    console.warn("[openDrawer] No hardwareController.imageUrl configured — skipping");
    return;
  }
  const ObFlag = tillData?.tillAccess?.cwrTill?.tillCloseTemplate?.obController === "Y" ? true : false;
  const CWHardwareController = tillData?.tillAccess?.cwrTill?.printTemplate?.cwController === "Y" ? true : false;
  let openDrawerPayload = "";
  if (CWHardwareController) {
    openDrawerPayload = JSON.stringify({
      cash_drawer: {
        action: "open",
      },
    });
  } else if (ObFlag) {
    openDrawerPayload = `<?xml version="1.0" encoding="UTF-8"?>
      <output>
      <opendrawer/>
      </output>`;
  }

  Axios.post(`${printerURL}printer`, openDrawerPayload, {
    notAPrint: true,
    headers: {
      "Content-Type": "application/xml; charset=UTF-8",
      Accept: "application/xml",
    },
  })
    .then(() => {
      console.log("[openDrawer] Axios path succeeded");
    })
    .catch((err) => {
      console.warn("[openDrawer] Axios path failed:", err?.message);
    });
};

export default openDrawer;
